// extracted by mini-css-extract-plugin
module.exports = {"list":"List_list__jJyzV","list__header":"List_list__header__ilCfD","list__more":"List_list__more__9GLfX","list_withpagination":"List_list_withpagination__5ct82"};